import { render } from "./layered_sso_client.vue?vue&type=template&id=604135d1"
import script from "./layered_sso_client.vue?vue&type=script&lang=js"
export * from "./layered_sso_client.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__